import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../core/service/common-service/common.service';
import { ListCustData } from './listCustData';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { DatePipe } from '@angular/common';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';

@Component({
  selector: 'app-prs-calling-list',
  templateUrl: './prs-calling-list.component.html',
  styleUrls: ['./prs-calling-list.component.scss'],
  providers: [FilterPipePipe]
})
export class PrsCallingListComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('filterSelect', { static: true }) filterSelect: MatSelect;

  callStats: any = {};
  spinner: boolean;
  userId: string;
  userRoles: any;
  selectedRegionValues: string[] = [];
  selectedStateValues: string[] = [];
  selectedDealerCodeValues: string[] = [];
  //selectedCallTypeValues: string;
  selectedVerticalValues: string[] = [];
  selectedLanguageValues: string[] = [];
  selectedAccountValues: string[] = [];
  uniqueRegionValue = new Set<string>();
  uniqueStateValue = new Set<string>();
  uniqueDealerCodeSet = new Set<string>();
  //uniqueCallType = new Set<string>();
  uniqueVerticalValue = new Set<string>();
  uniqueLanguage = new Set<string>();
  uniqueAccountType = new Set<string>();
  callToggleStatus: boolean = true;
  selection: any;
  callFlag: any;
  callsToBeMade: number = 0;
  dataSource: any;
  selectedCol: string;
  customerData: any;
  currentDate: string;
  selectedColValues: string[] = [];
  pageSize: number;
  filteredDataSource: any;
  callsMade: number = 0;
  customersToBeCalled: string;
  callsMade1: string;
  filterMap = new Map();
  uniqueVerticalValueArray :string[] = [];
  selectedDealer: any;
  uniqueDealerCodeCopy: string[] = [];
  uniqueDealerCode: string[] = [];
  dealerCode: string[] = [];
  displayedColumns: string[] = [
    'customerName',
    'customerTel',
    'accountType',
    'callType',
    'callStatus',
    'dealerCode',
    'dealerLocation',
    'dealerCategory',
    'custLanguage',
    'creInput',
    'followUpTime',
    'remarks'
  ];

  //call type selection
  // uniqueCallType: any[] = [
  //   { value: 1, type: '1st Month - Sales Experience' },
  //   { value: 3, type: 'PRS-Post Repair Survey' },
  //   { value: 4, type: '4th Month - Product Experience' },
  //   { value: 9, type: '9th Month - Service Experience' }
  // ];

  // uniqueCallType: string[] = ['PRS-Post Repair Survey','1st Month - Sales Experience','4th Month - Product Experience','9th Month - Service Experience'];
  // //uniqueRegionValue: string[] = ['North - II','North - I','West','East - II','East - I','South - I','Central','South - II'];
  // selectedCallTypeValues: string = '1st Month - Sales Experience';
  uniqueCallType: string[] = [];
  //uniqueRegionValue: string[] = ['North - II','North - I','West','East - II','East - I','South - I','Central','South - II'];
  selectedCallTypeValues: string = '';
  selectedCallType: string;
  callTypeFlag: string;
  //selectedRegionValues: string = 'North - II';
  //regionFlag: string;
  custDataSource: string[] = [];
  roleId: string;
  filteredDataSourceCopy: any;
  filteredDataSourceLength: any;
  search: any;

  constructor(private router: Router,private toastr: ToastrService,private commonService: CommonService,
    private datePipe: DatePipe, private filterPipePipe: FilterPipePipe, private changeDetectorRefs: ChangeDetectorRef,) { }

  ngOnInit() {
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.userRoles = localStorage.getItem('userRoles');

    if(this.userRoles == 'CRE') {
      this.uniqueCallType = ['PRS-Post Repair Survey'];
      this.selectedCallTypeValues = 'PRS-Post Repair Survey';
    } else {
      this.uniqueCallType = ['PRS-Post Repair Survey','1st Month - Sales Experience','4th Month - Product Experience','9th Month - Service Experience'];
      this.selectedCallTypeValues = 'PRS-Post Repair Survey';
    }
    this.commonService.countryCode=localStorage.getItem('countryCode');
    this.commonService.roleId = localStorage.getItem('roleId');
    this.roleId = localStorage.getItem('roleId');
    //this.selectedCallTypeValues.push("1");
    if (localStorage.getItem('selectedRegionValues') != null || localStorage.getItem('selectedRegionValues') != undefined) {
      let selectedRegionValues = JSON.parse(localStorage.getItem('selectedRegionValues'));
      this.selectedRegionValues = selectedRegionValues;
    }

    if (localStorage.getItem('selectedStateValues') != null || localStorage.getItem('selectedStateValues') != undefined) {
      let selectedStateValues = JSON.parse(localStorage.getItem('selectedStateValues'));
      this.selectedStateValues = selectedStateValues;
    }

    if (localStorage.getItem('selectedDealerCodeValues') != null || localStorage.getItem('selectedDealerCodeValues') != undefined) {
      let selectedDealerCodeValues = JSON.parse(localStorage.getItem('selectedDealerCodeValues'));
      this.selectedDealerCodeValues = selectedDealerCodeValues;
    }

    if (localStorage.getItem('selectedCallTypeValues') != null || localStorage.getItem('selectedCallTypeValues') != undefined) {
      let selectedCallTypeValues = (localStorage.getItem('selectedCallTypeValues'));
      this.selectedCallTypeValues = selectedCallTypeValues;
    }

    if (localStorage.getItem('selectedVerticalValues') != null || localStorage.getItem('selectedVerticalValues') != undefined) {
      let selectedVerticalValues = JSON.parse(localStorage.getItem('selectedVerticalValues'));
      this.selectedVerticalValues = selectedVerticalValues;
    }

    if (localStorage.getItem('selectedLanguageValues') != null || localStorage.getItem('selectedLanguageValues') != undefined) {
      let selectedLanguageValues = JSON.parse(localStorage.getItem('selectedLanguageValues'));
      this.selectedLanguageValues = selectedLanguageValues;
    }

    if (localStorage.getItem('selectedAccountValues') != null || localStorage.getItem('selectedAccountValues') != undefined) {
      let selectedAccountValues = JSON.parse(localStorage.getItem('selectedAccountValues'));
      this.selectedAccountValues = selectedAccountValues;
    }

    if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('callListPageSize'));
      this.pageSize = (pagesize && pagesize != NaN) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }

    if ((localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) && this.userRoles !='Call Center Agent') {
      this.getWorkshopDetails();
    }
    this.callTypeFlag = this.selectedCallTypeValues;
    this.getCreStats();
    this.filterValue();
    this.callListinfo();

    this.commonService.startInterval();
    this.commonService.followupResponse && this.commonService.followupResponse.subscribe((res) => {
      this.commonService.prsFollowupDataSource = [];
      if(res['responseCode'] == 0) {
        res['responseData'].forEach((element) => {
          this.commonService.prsFollowupDataSource.push(element);
          let callListItem = this.commonService.prsCallListResponseData.find((ele) => {return ele.customerId == element.customerId});
          let index = this.commonService.prsCallListResponseData.findIndex((ele) => {return ele.customerId == element.customerId});
          if(index != -1) {
            this.commonService.prsCallListResponseData.splice(index, 1);
          }
        });
        this.commonService.prsFollowupDataSource.forEach((val) => {
          this.commonService.prsCallListResponseData.unshift(val);
        })
      } else {
        this.commonService.prsFollowupDataSource = [];
        // this.toastr.error(res['message'], "Error");
      }
    }, error => {
      // this.toastr.error("Something went wrong, Please try again.", "Error");
    });

    if(!this.commonService.prsCallListResponseData.length){
      this.prepairCallList('Y', this.selectedCallType)
    } else {
      let custRes = this.commonService.prsCustomerResponse;
      if(custRes) {
        let customerId = custRes['customerId'];
        this.getCallListCustCode('N', customerId);
      } else {
        this.getCustomerResponse();
        this.setCallListData('Y');
      }
    }
  }

  filterValue() {
    if(this.selectedCallTypeValues == '1st Month - Sales Experience') {
      this.selectedCallType = '1';
    } else if(this.selectedCallTypeValues == 'PRS-Post Repair Survey') {
      this.selectedCallType = '3';
    } else if(this.selectedCallTypeValues == '4th Month - Product Experience') {
      this.selectedCallType = '4';
    } else if(this.selectedCallTypeValues == '9th Month - Service Experience') {
      this.selectedCallType = '9';
    }
    this.commonService.prsCallType = this.selectedCallType;
  }

  getCallListCustCode(callDoneInd: string, custCode: string) {
    this.spinner = true;
    this.commonService.getPRSCustCallList(callDoneInd, this.selectedCallType, custCode, this.roleId, this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          res['responseData'].forEach((element) => {
            this.custDataSource.push(element);
          });
          this.spinner = false;
        } else {
          this.spinner = false;
          //this.toastr.error(res['message'], "Error");
        }
        this.getCustomerResponse();
        this.setCallListData('Y');
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  getCustomerResponse() {
    let custResp = this.commonService.prsCustomerResponse;

    if(custResp) {
      let custId = custResp['customerId'];
      let callListItem = this.commonService.prsCallListResponseData.find((element) => {return element.customerId == custId});
      let index = this.commonService.prsCallListResponseData.findIndex((element) => {return element.customerId == custId});

      if(this.custDataSource[0] && (this.custDataSource[0]['callStatus'] == 'Try Again'
          || this.custDataSource[0]['callStatus'] == 'Pending'
          || this.custDataSource[0]['callStatus'] == 'Pending Try-Again')) {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1);
        }
        this.custDataSource.forEach((element) => {
          this.commonService.prsCallListResponseData.push(element);
        });
      } else if(this.custDataSource[0] && (this.custDataSource[0]['callStatus'] == 'Queued')) {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1, this.custDataSource[0]);
        }
      } else if(this.custDataSource[0] && (this.custDataSource[0]['callStatus'] == 'Try Again Contacted'
        || this.custDataSource[0]['callStatus'] == 'Booking Confirmed'
        || this.custDataSource[0]['callStatus'] == 'No Service')) {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1);
        }
      } else if(this.custDataSource[0] && (this.custDataSource[0]['creInput'] == 'Contact Fleet Manager')) {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1);
        }
        this.commonService.prsCallListResponseData.unshift(this.custDataSource[0]);
      } else if(this.custDataSource[0] && (this.custDataSource[0]['creInput'] == 'Contact Driver')) {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1);
        }
        this.commonService.prsCallListResponseData.unshift(this.custDataSource[0]);
      } else {
        if(index != -1) {
          this.commonService.prsCallListResponseData.splice(index, 1);
        }
      }
    }
    this.commonService.prsCustomerResponse = '';
  }

  getCallToBeMadeCallList(flag: string) {
    if(!this.commonService.prsCallListResponseData.length){
      this.prepairCallList(flag, this.selectedCallType)
    } else {
      this.setCallListData(flag);
    }
    const index = this.displayedColumns.findIndex(item => item === 'complaintId');
    if (index !== -1) {
      this.displayedColumns.splice(index, 1);
    }
  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
 setPageData(event) {
  let size = event.pageSize.toString();
  localStorage.setItem('callListPageSize', size);
}

/**
  * Name: getWorkshopDetails
  * purpose: To get CRE assigned workshop details
  */
 getWorkshopDetails() {
  this.spinner = true;
  this.commonService.getWorkshopDetails(this.userId)
    .subscribe(res => {
      if (res['responseCode'] == 0) {
        this.spinner = false;
        localStorage.setItem('workshops', JSON.stringify(res['responseData']));
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
}

  /**
    * Name: getCreStats
    * purpose: To get call count info
    */
   getCreStats(): void {
    this.spinner = true;
    this.commonService.getPrsCallStats(this.userId, this.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.spinner = false;
          this.callStats = res['responseData'][0];
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: activeButton
   * purpose: To activat apply button
   */
  activeButton(): boolean {
    let flag = false;
    if(this.selectedRegionValues != null && this.selectedRegionValues.length != 0) {
      flag = true;
    } else if (this.selectedStateValues != null && this.selectedStateValues.length != 0) {
       flag = true;
    } else if(this.selectedDealerCodeValues != null && this.selectedDealerCodeValues.length != 0) {
      flag = true;
    } else if(this.selectedCallTypeValues != null) {
      flag = true;
    } else if (this.selectedVerticalValues != null && this.selectedVerticalValues.length != 0) {
      flag = true;
   } else if(this.selectedLanguageValues != null && this.selectedLanguageValues.length != 0) {
     flag = true;
   } else if(this.selectedAccountValues != null && this.selectedAccountValues.length != 0) {
    flag = true;
  }
    return flag;
  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    let key = '';
    this.filterMap = new Map();

    this.filterValue();
    if(this.selectedCallTypeValues != this.callTypeFlag) {
      localStorage.setItem('selectedCallTypeValues',(this.selectedCallTypeValues));
      //localStorage.setItem('selectedRegionValues',JSON.stringify(this.selectedRegionValues));
      this.callTypeFlag = this.selectedCallTypeValues;
      //this.regionFlag = this.selectedRegionValues;
      this.callTypeApply();
    } else {
      this.otherFilterApply();
    }
  }

  callTypeApply() {
    this.prepairCallList('Y', this.selectedCallType);
  }

  otherFilterApply() {
    this.filteredDataSource = this.dataSource;
    let key = '';
    if(this.selectedRegionValues != null && this.selectedRegionValues.length != 0){
      key = "dealerRegion";
      this.filterMap.set(key, this.selectedRegionValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedStateValues != null && this.selectedStateValues.length != 0){
      key = "dealerLocation";
      this.filterMap.set(key, this.selectedStateValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedDealerCodeValues != null && this.selectedDealerCodeValues.length != 0){
      key = "dealerCode";
      this.filterMap.set(key, this.selectedDealerCodeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedVerticalValues != null && this.selectedVerticalValues.length != 0){
      key = "vertical";
      this.filterMap.set(key, this.selectedVerticalValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedLanguageValues != null && this.selectedLanguageValues.length != 0){
      key = "custLanguage";
      this.filterMap.set(key, this.selectedLanguageValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if(this.selectedAccountValues != null && this.selectedAccountValues.length != 0){
      key = "accountType";
      this.filterMap.set(key, this.selectedAccountValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }
    //this.filterMap.set(this.selectedCol, this.selectedColValues);
    //this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    localStorage.setItem('selectedRegionValues',JSON.stringify(this.selectedRegionValues));
    localStorage.setItem('selectedStateValues',JSON.stringify(this.selectedStateValues));
    localStorage.setItem('selectedDealerCodeValues',JSON.stringify(this.selectedDealerCodeValues));
    //localStorage.setItem('selectedCallTypeValues',(this.selectedCallTypeValues));
    localStorage.setItem('selectedVerticalValues',JSON.stringify(this.selectedVerticalValues));
    localStorage.setItem('selectedLanguageValues',JSON.stringify(this.selectedLanguageValues));
    localStorage.setItem('selectedAccountValues',JSON.stringify(this.selectedAccountValues));
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on call list data
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filteredDataSource.filter = filterValue;
  }

  /**
    * Name: prepairCallList
    * purpose: To get calllist details
    * @param {string} flag - type of call
    */
   prepairCallList(flag: string, callType: string): void {
    this.spinner = true;
    this.selection = new SelectionModel<ListCustData>(true, []);
   // this.dataSource = '';
    this.commonService.prscustomercallList(flag, callType, this.userId, this.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (flag == 'Y') {
            this.callFlag = flag;
            this.callToggleStatus = true;
          } else {
            this.callFlag = flag;
            this.callToggleStatus = false;
          }
          if (res['responseData'].length) {
            let response = res['responseData'];
            if(flag == 'Y') {
              this.commonService.prsCallListResponseData = response;
            }
            response.forEach(data => {
              // if ((data.accountType).toLowerCase() == "lost") {
              //   let changeName = data.customerName.split(" - L")[0];
              //   data.customerName = changeName;
              // }
              let inboundCustomer = data.customerName && data.customerName.includes("- I"); 
              let stringPosition = data.customerName.length;
              let lostString = data.customerName[stringPosition - 3] + data.customerName[stringPosition - 2] + data.customerName[stringPosition - 1]
              if (inboundCustomer && lostString == "- I") {
                let changeName = data.customerName.split(" - I")[0];
                data.customerName = changeName;
                data.isInboundCall = true;
              }
            });
            this.callsToBeMade = response.length;
            this.dataSource = new MatTableDataSource<ListCustData>(response);
            this.filteredDataSource = this.dataSource;
            this.filteredDataSourceCopy = this.dataSource;
            this.sort.direction = '';
            this.dataSource.sort = this.sort;
            this.dataSource.sortingDataAccessor = (data, header) => data[header];
            this.dataSource.paginator = this.paginator;
            this.filterData();
            this.otherFilterApply();
            //this.callListinfo();
            this.spinner = false;
          }
          //this.callsToBeMade = res['responseData'].length;
          //init data table and shorting
          // this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          // this.filteredDataSource = this.dataSource;
          // this.sort.direction = '';
          // this.dataSource.sort = this.sort;
          // this.dataSource.sortingDataAccessor = (data, header) => data[header];
          // this.dataSource.paginator = this.paginator;
          // this.filterData();
          // this.otherFilterApply();
          // if ((!this.selectedRegionValues || this.selectedRegionValues.length == 0)
          // && (!this.selectedStateValues || this.selectedStateValues.length == 0)
          // && (!this.selectedDealerCodeValues || this.selectedDealerCodeValues.length == 0)
          // //&& (this.selectedCallTypeValues)
          // && (!this.selectedVerticalValues || this.selectedVerticalValues.length == 0)
          // && (!this.selectedLanguageValues || this.selectedLanguageValues.length == 0)
          // && (!this.selectedAccountValues || this.selectedAccountValues.length == 0)) {
          //   //init filtered table and shorting
          //   this.filteredDataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          //   this.sort.direction = '';
          //   this.filteredDataSource.sort = this.sort;
          //   this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
          //   this.filteredDataSource.paginator = this.paginator;
          // }
          //this.spinner = false;
          //this.callsMadeCalculate(res['responseData']);
          //this.callListinfo();
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
          this.callToggleStatus = true;
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.callToggleStatus = true;
      });
  }

  setCallListData(flag: string) {
    let response;
    if(flag == 'Y') {
      response = this.commonService.prsCallListResponseData;
    }
    if (flag == 'Y') {
      this.callFlag = flag;
      this.callToggleStatus = true;
    } else {
      this.callFlag = flag;
      this.callToggleStatus = false;
    }

    if (response.length) {
      response.forEach(data => {
        // if ((data.accountType).toLowerCase() == "lost") {
        //   let changeName = data.customerName.split(" - L")[0];
        //   data.customerName = changeName;
        // }
        let inboundCustomer = data.customerName.includes("- I");
        let stringPosition = data.customerName.length;
        let lostString = data.customerName[stringPosition - 3] + data.customerName[stringPosition - 2] + data.customerName[stringPosition - 1]
        if (inboundCustomer && lostString == "- I") {
          let changeName = data.customerName.split(" - I")[0];
          data.customerName = changeName;
          data.isInboundCall = true;
        }
      });
      this.callsToBeMade = response.length;
      this.dataSource = new MatTableDataSource<ListCustData>(response);
      this.filteredDataSource = this.dataSource;
      this.sort.direction = '';
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (data, header) => data[header];
      this.dataSource.paginator = this.paginator;
      this.filterData();
      this.otherFilterApply();
      this.callListinfo();
      this.spinner = false;
    }
  }

  /**
  * Name: callsMadeCalculate
  * purpose: To get call made count
  * @param {Array} callsToBeMade - list of calls
  */
  callsMadeCalculate(callsToBeMade: any) {
    this.callsMade = 0;
    callsToBeMade.forEach(element => {
      let currentDate = "" + this.datePipe.transform(new Date(), "yyyy-MM-dd");
      // let reqDate = this.datePipe.transform((element.lastCallTime), "yyyy-MM-dd");
      // if (currentDate == reqDate) {
      //   this.callsMade++;
      // }
    });
  }

  /**
    * Name: callListinfo
    * purpose: To get call count info
    */
   callListinfo(): void {
    this.spinner = true;
    this.commonService.prsCallListinfo(this.userId, this.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.customersToBeCalled = res['responseData'].callToBeMade;
          this.callsMade1 = res['responseData'].callMade;
          this.spinner = false;
        } else {
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        //...
      });
  }

  /**
    * Name: selectCustomer
    * purpose: To select customer for details
    * @param {Object} row - selected customer details
    */
   selectCustomer(row: ListCustData): void {
    localStorage.setItem('customerId', row.customerId);
    //localStorage.setItem('custNotification', row.serviceType + ", " + row.callStatusDesc);
    localStorage.setItem("vin", row.vin);
    localStorage.setItem("dealerCode", row.dealerCode);
    localStorage.setItem("customerData", JSON.stringify(row));
    this.router.navigate(['prs-customer360']);
  }

   /**
   * Name: filterData
   * purpose: To filter call list data
   */
  filterData(): void {
    this.dataSource.filteredData.forEach(element => {
      this.uniqueRegionValue.add(element.dealerRegion);
      //this.uniqueCallType.add(element.callType);
      this.uniqueStateValue.add(element.dealerLocation);
      this.uniqueDealerCodeSet.add(element.dealerCode);
      this.uniqueVerticalValue.add(element.vertical);
      this.uniqueLanguage.add(element.custLanguage);
      this.uniqueAccountType.add(element.accountType);
    });
    this.uniqueDealerCode = Array.from(this.uniqueDealerCodeSet);
    this.uniqueDealerCodeCopy = this.uniqueDealerCode;
    let verticalArray = Array.from(this.uniqueVerticalValue);
    verticalArray.forEach((element,index)=>{

      if(element == null){
        verticalArray.splice(index,1);
      }
    });
    this.uniqueVerticalValueArray = verticalArray;
    localStorage.setItem("uniqueRegionValue", JSON.stringify((this.uniqueRegionValue)));
    localStorage.setItem("uniqueVerticalValue", JSON.stringify(this.uniqueVerticalValueArray));
    localStorage.setItem("uniqueDealerCode", JSON.stringify(this.uniqueDealerCode));

    // if ((this.selectedRegionValues != null && this.selectedRegionValues.length != 0)
    // || (this.selectedStateValues != null && this.selectedStateValues.length != 0)
    // || (this.selectedDealerCodeValues != null && this.selectedDealerCodeValues.length != 0)
    // //|| (this.selectedCallTypeValues[0] != '1')
    // || (this.selectedVerticalValues != null && this.selectedVerticalValues.length != 0)
    // || (this.selectedLanguageValues != null && this.selectedLanguageValues.length != 0)
    // || (this.selectedAccountValues != null && this.selectedAccountValues.length != 0)) {
    //   //this.filterTriggered(null);
    //   this.applyfilter();
    // }
  }

   /**
   * Name: clearFilter
   * purpose: To clear filter
   */
  clearFilter(listChange:boolean, listType: string): void {
    if(listType=='X' && this.displayedColumns.filter(item => item == 'complaintId').length == 0){
      this.displayedColumns.push('complaintId');
    }
    if(listChange) {
      this.dataSource = [];
      this.filteredDataSource = [];
      this.filterValue();
      this.prepairCallList(listType,this.selectedCallType);
    } else {
      this.filterMap.clear();
      this.selectedCol = null;
      this.selectedColValues = null;
      this.selectedRegionValues = null;
      this.selectedStateValues = null;
      this.selectedDealerCodeValues = null;
      this.selectedVerticalValues = null;
      this.selectedLanguageValues = null;
      this.selectedAccountValues = null;
      if(this.selectedCallTypeValues == 'PRS-Post Repair Survey'){
        this.filterValue();
        this.prepairCallList(listType,this.selectedCallType);
      } else {
        this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
        this.callsToBeMade = this.filteredDataSource.filteredData.length;
        this.sort.direction = '';
        this.filteredDataSource.sort = this.sort;
        this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
        this.filteredDataSource.paginator = this.paginator;
      }
      this.selectedCallTypeValues = 'PRS-Post Repair Survey';
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
      this.callsToBeMade = this.filteredDataSource.filteredData.length;
      this.sort.direction = '';
      this.filteredDataSource.sort = this.sort;
      this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
      this.filteredDataSource.paginator = this.paginator;
      localStorage.removeItem('selectedRegionValues');
      localStorage.removeItem('selectedStateValues');
      localStorage.removeItem('selectedDealerCodeValues');
      localStorage.removeItem('selectedCallTypeValues');
      localStorage.removeItem('selectedVerticalValues');
      localStorage.removeItem('selectedLanguageValues');
      localStorage.removeItem('selectedAccountValues');
      localStorage.removeItem('selectedCol');
      localStorage.removeItem('selectedColValues');
    }
  }

  /**
   * Name: refreshCallList
   * purpose: To refresh call list
   */
  refreshCallList(): void {
    this.spinner = true;
    this.commonService.prscustomercallList('Y',this.selectedCallTypeValues, this.userId, this.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          this.callsToBeMade = res['responseData'].length;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.callsMadeCalculate(res['responseData']);
          this.spinner = false;
          this.changeDetectorRefs.detectChanges();
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: changeColor
   * purpose: To change followup time color
   */
  changeColor(followUp:any): String {
    let currentTime = this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss ");

    if(followUp != null && followUp != undefined  && followUp != "") {
      let followUpDateTime = this.datePipe.transform(followUp, "yyyy-MM-dd HH:mm:ss");
      if((new Date(currentTime)).getTime() > (new Date(followUpDateTime).getTime())){
        return "red";
      }
    }
  }

  onKey() : void {
    this.uniqueDealerCode = this.uniqueDealerCodeCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectedDealer.trim();
    this.dealerCode = this.uniqueDealerCode.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.uniqueDealerCode = [];
    this.uniqueDealerCode = this.dealerCode;
  }

  closeInput() : void {
   if(this.dealerCode.length == 0) {
    this.selectedDealer = '';
    this.uniqueDealerCode = this.uniqueDealerCodeCopy;
   }
  }

  searchfilter1(filterValue: string): void {
      this.filteredDataSource = this.filteredDataSourceCopy;
      if(filterValue != "") {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
      }
      this.filteredDataSource.filter = filterValue;
      this.filteredDataSourceLength = this.filteredDataSource.filteredData.length;
      if(filterValue == "") {
        this.filteredDataSource = this.filteredDataSourceCopy;
      }
    }
}